/** Injected by vite.config.ts (`define`); absent in tests and unbundled runs. */
declare const __TAX_BUILD_VERSION__: string | undefined;

/** The web build identifier: package version + commit + build time (session replay "Versão"). */
export const BUILD_VERSION: string | undefined =
  typeof __TAX_BUILD_VERSION__ === "string" && __TAX_BUILD_VERSION__.trim()
    ? __TAX_BUILD_VERSION__.trim().slice(0, 64)
    : undefined;
